import { Avatar, Button, Card, Heading, If, Progress, Stack, Text, View } from '@fold-dev/core'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { logger } from '../helpers/util'
import { useWorkspaceInvites, useWorkspaces, useWorkspaceUsers } from '../hooks/api.hooks'

export const WorkspaceJoinLayout = (props) => {
    const workspacesAPI = useWorkspaces()
    const workspaceUsersAPI = useWorkspaceUsers()
    const workspaceInvitesAPI = useWorkspaceInvites()
    const [error, setError] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const [joined, setJoined] = useState(false)
    const [image, setImage] = useState('')
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [shortcode, setShortcode] = useState('')
    const [searchParams] = useSearchParams()
    const invite = searchParams.get('invite')
    const workspaceId = searchParams.get('workspaceId')
    const navigate = useNavigate()

    const handleWorkspaceJoin = async () => {
        setLoading(true)
        setError(false)

        try {
            await workspaceInvitesAPI.redeem(workspaceId, invite)

            setLoading(false)
            setJoined(true)
        } catch (e) {
            setLoading(false)
            setError('Could not join workspace')
        }
    }

    useEffect(() => {
        if (workspaceId) {
            ;(async () => {
                setLoading(true)

                try {
                    const { image, name, description } = await workspacesAPI.getOnePublic(workspaceId)

                    setImage(image)
                    setName(name)
                    setDescription(description)
                    setLoading(false)
                } catch (e) {
                    logger(e)
                    setLoading(false)
                    setError('Something has gone wrong')
                }
            })()
        }
    }, [workspaceId])

    return (
        <View
            column
            width="100%"
            height="100%"
            position="absolute"
            bg="linear-gradient(45deg, var(--f-color-surface), var(--f-color-surface-strong))">
            <If if={loading}>
                <Progress
                    value={50}
                    thickness={5}
                    indeterminate
                    bgToken="transparent"
                    position="absolute"
                    variant="success"
                    style={{
                        '--f-progress-radius': 0,
                        'top': 0,
                        'left': 0,
                    }}
                />
            </If>

            <Card
                column
                p={50}
                width={400}
                className="workspace-page">
                <Stack
                    direction="vertical"
                    spacing={20}
                    justifyContent="center"
                    noStretch>
                    <Avatar
                        src={image}
                        name={name}
                        size="xl"
                    />
                    <Heading>{name}</Heading>

                    <If if={!joined}>
                        <div
                            style={{ textAlign: 'center' }}
                            className="f-text"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                        <Text textAlign="center">
                            You have been invited to join {name} - click on the button below to join now.
                        </Text>
                        <Button
                            onClick={handleWorkspaceJoin}
                            size="lg"
                            variant="accent"
                            disabled={loading}>
                            Join Now
                        </Button>
                    </If>

                    <If if={joined}>
                        <Text
                            textAlign="center"
                            size="lg">
                            Congratulations!
                        </Text>
                        <Text textAlign="center">
                            You have successfully joined this workspace. Click on the button to start.
                        </Text>
                        <Button
                            onClick={() => navigate('/app/workspace/' + workspaceId + '/inbox')}
                            size="lg"
                            variant="accent"
                            disabled={loading}>
                            Start
                        </Button>
                    </If>

                    <If if={error}>
                        <Text
                            size="sm"
                            fontWeight="bold"
                            onClick={() => setError(null)}
                            colorToken="danger">
                            {error}
                        </Text>
                    </If>
                </Stack>
            </Card>
        </View>
    )
}
